import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "text-subtitle-2" }
const _hoisted_3 = { class: "text-subtitle-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle-1" }, "shalan@al-otaishan.com.sa", -1)
const _hoisted_5 = { class: "text-subtitle-2" }
const _hoisted_6 = { class: "text-subtitle-1" }

import { ref, onMounted } from 'vue';
import { useGlobalStore, useConfigStore } from '@/stores';
import { useRoute } from 'vue-router';
import { $t } from '@/i18n';

// components
import PageTitle from '@/components/PageTitle.vue';
import ContactUsForm from '@/components/ContactUsForm.vue';
import GoogleMap from '@/components/GoogleMap.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUsPage',
  setup(__props) {

const $route = useRoute();
const globalStore = useGlobalStore();
const configStore = useConfigStore();

const pageTitleRef = ref();

onMounted(() => {
  globalStore.createVisit($route.path, $t('CONTACT_US'));
  pageTitleRef.value.pageTitle = $t('CONTACT_US');
});

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_WebsiteLayout = _resolveComponent("WebsiteLayout")!

  return (_openBlock(), _createBlock(_component_WebsiteLayout, null, {
    content: _withCtx(() => [
      _createVNode(PageTitle, {
        ref_key: "pageTitleRef",
        ref: pageTitleRef,
        "page-title": _unref($t)('CONTACT_US')
      }, null, 8, ["page-title"]),
      _createVNode(ContactUsForm),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($t)('COMMUNICATING_WITH_CEO')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString('0138819666 ' + _unref($t)('TEL_EXT') + ' 626'), 1),
        _hoisted_4,
        _createVNode(_component_v_divider),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref($t)('ADDRESS')) + ":", 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(configStore).stringLang(
              _unref(globalStore).organization.addressAr,
              _unref(globalStore).organization.addressEn
            )), 1)
      ]),
      _createVNode(GoogleMap)
    ]),
    _: 1
  }))
}
}

})